import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {  
    Pagination,
    Container,
  } from 'semantic-ui-react';

class PaginationContainer extends Component {
    constructor(props) {
        super(props);            

      }

      static get propTypes() { 
        return { 
           registers: PropTypes.any,
           onPageChange: PropTypes.func
        }; 
      }
      
      handlePageChange = (e, { activePage }) => {      
        const { onPageChange } = this.props;
        if (onPageChange) {
            onPageChange(e, { activePage })
        }
      }
        
      render() {
          const { registers } = this.props;
          
          if (!registers || !registers.Results) {
              return '';
          }
          
          return (
            <Container className='pagination-container'>                
                {registers.TotalNumberOfPages > 1 && <Pagination 
                    pointing
                    secondary
                    size='mini'
                    firstItem={registers.PageNumber != 1 ? undefined : null} 
                    lastItem={registers.PageNumber != registers.TotalNumberOfPages ? undefined : null} 
                    nextItem={registers.PageNumber != registers.TotalNumberOfPages ? undefined : null}                  
                    prevItem={registers.PageNumber != 1 ? undefined : null} 
                    activePage={registers.PageNumber} 
                    totalPages={registers.TotalNumberOfPages} 
                    onPageChange={this.handlePageChange} />}          
                <p>Mostrando {registers.Results.length} registros de {registers.TotalNumberOfRecords}</p>
            </Container>          
        );
      }
}

export { PaginationContainer };